export type AppRoute = 'proposal' | 'shop' | 'case' | 'not-found'

export function resolveRoute(path: string): AppRoute {
  const normalizedPath = path.length > 1 ? path.replace(/\/+$/, '') : path

  if (normalizedPath === '/') {
    return 'proposal'
  }

  if (normalizedPath === '/experience') {
    return 'shop'
  }

  if (normalizedPath === '/direct-delivery-case') {
    return 'case'
  }

  return 'not-found'
}
